import { Dispatch, SetStateAction, useEffect, useState } from 'react';

const useInitialState = <T>(initialValue: T): [T, Dispatch<SetStateAction<T>>] => {
  const [value, setValue] = useState(initialValue);
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return [value, setValue];
};

export default useInitialState;
